import { render } from "./Ordering.vue?vue&type=template&id=41b31126&scoped=true"
import script from "./Ordering.vue?vue&type=script&lang=js"
export * from "./Ordering.vue?vue&type=script&lang=js"

import "./Ordering.vue?vue&type=style&index=0&id=41b31126&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b31126"]])

export default __exports__